module.exports = ".fixedNav{\n    margin-top: 56px;\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/pages/dash/dash.component.css
// module id = ./src/app/pages/dash/dash.component.css
// module chunks = main